import _ from 'lodash';
import ThumbBucketLocationType from '../entities/thumbBucketLocationType';
import BucketBrandType from '../entities/bucketBrandType';
export const leadTimeInDaysCutoff = 15;

export function getQuoteProductLeadTime(quoteProduct, configuration) {
  const product = configuration.products.find((x) => x.id === quoteProduct.productId);

  if (!product)
    return;

  const isAmiBucket = !!quoteProduct.detail && (quoteProduct.detail.bucketLocation === ThumbBucketLocationType.SameQuote || quoteProduct.detail.bucketLocation === ThumbBucketLocationType.ExistingQuote && quoteProduct.detail.existingBucket && quoteProduct.detail.existingBucket.brand === BucketBrandType.ami.id);
  const forceUseStandardLead = !isAmiBucket && product.thumbForceStandardLeadTimeForNonAmiBucket;
  const leadTime = forceUseStandardLead ? product.leadTime.standard : product.leadTime.supportsFastTrack ? product.leadTime.fastTrack : product.leadTime.standard;

  let productLeadTime = quoteProduct.buildToOrderLeadTimeOverride || leadTime;

  const inventoryItem = quoteProduct.inventoryItemId ? configuration.inventoryItems.find((x) => x.id === quoteProduct.inventoryItemId) : null;
  const inventoryItemLeadTime = inventoryItem ? quoteProduct.inventoryLeadTimeOverride || inventoryItem.leadTime : null;

  const productOptions = quoteProduct.productOptions.filter((x) => x.productOptionId).map((x) =>
    configuration.getProductOption(
      quoteProduct.productGroupId,
      x.productOptionSetId,
      x.productOptionId,
      true
    )
  )
    .filter((x) => x);

  const nonEmptyLeadTimes = quoteProduct.productOptions.filter((x) => x.productOptionId).map((x) => {
    if (x.leadTimeOverride)
      return x.leadTimeOverride;

    const productOption = productOptions.find((po) => po.id === x.productOptionId);
    if (!productOption) {
      return x.leadTime; // return the existing lead time
    }

    return productOption.leadTime;
  }).filter((x) => x);

  if (quoteProduct.buildToOrderLeadTimeOverride === null && product.leadTime.fastTrack && productOptions.some((p) => p.type === 'AMICustomization' && p.supportsFastTrackLeadTimes === false)) {
    // we want to add the product's standard lead time to the list because there is an AMI customization option that doesn't support FT enabled
    nonEmptyLeadTimes.push(product.leadTime.standard);
  }

  if (inventoryItemLeadTime) {
    nonEmptyLeadTimes.push(inventoryItemLeadTime);
    return _.sortBy(nonEmptyLeadTimes, [(x) => x.numberOfDays * -1])[0];
  }

  if (productLeadTime) {
    if (productLeadTime.numberOfDays) {
      nonEmptyLeadTimes.push(productLeadTime);
    } else {
      return null; // the product lead time being null ("Call") trumps everything else
    }
  }

  return nonEmptyLeadTimes.length > 0
    ? _.sortBy(nonEmptyLeadTimes, [(x) => x.numberOfDays * -1])[0]
    : null;
}
